module.exports = __webpack_public_path__ + "static/media/photo 123.d567c088.jpg";